export class TLVCacheService {
  constructor ($q) {
    'ngInject';
    this.cache = {};
    this.$q = $q;
  }

  clear() {
    delete this.cache;
    this.cache = {};
  }

  get(key, calculate, date, update) {
    var isFound = this.cache[key] != undefined;
    var defer = this.$q.defer();
    var value = isFound && this.cache[key].value;
    var cacheDate = isFound && this.cache[key].date;
    var sameDate = (cacheDate && cacheDate == date) || (!cacheDate && !date);

    var recalculate = (id, f, t, q) => {
      var request = f();

      if(request.then){
        request.then(
          (success) => {
            this.cache[id] = {};
            this.cache[id].value = success;
            this.cache[id].date =  t;
            q.resolve(success);
          },
          (error) => {
            q.reject(error);
          });
      } else {
        q.resolve(request);
      }
    };
    if(!isFound || (isFound && !sameDate) || update) {
      recalculate(key, calculate, date, defer);
    }
    if(isFound && sameDate && !update) {
      defer.resolve(value);
    }
    return defer.promise;
  }


}
